import { render } from "./doctorPreview.vue?vue&type=template&id=033a131e"
import script from "./doctorPreview.vue?vue&type=script&lang=js"
export * from "./doctorPreview.vue?vue&type=script&lang=js"

import "./doctorPreview.vue?vue&type=style&index=0&id=033a131e&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__